

export const getAdImageUrl = (API_ROOT) => {
  // const sessionStarted = sessionStorage.getItem("adSessionStarted");
  // console.log('check session ', sessionStarted)
  // const count = parseInt(
  //   localStorage.getItem("adVisitCount") || "0",
  //   10
  // );

  // let newSession = sessionStarted !== "true";
  // console.log('new session', newSession);

  // if (newSession) {
  //   sessionStorage.setItem("adSessionStarted", true);
  // }

  // console.log('new session1', newSession);
  return `${API_ROOT}/api/advertisement/get_active`;
};

